import { render, staticRenderFns } from "./AddPhotos.vue?vue&type=template&id=94ef8d40&scoped=true&"
import script from "./AddPhotos.vue?vue&type=script&lang=js&"
export * from "./AddPhotos.vue?vue&type=script&lang=js&"
import style0 from "./AddPhotos.vue?vue&type=style&index=0&id=94ef8d40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ef8d40",
  null
  
)

export default component.exports